/*
 * @Description: 
 * @Author: zhaoshuai
 * @Date: 2020-05-07 13:41:28
 * @LastEditTime: 2021-06-10 17:42:55
 * @LastEditors: dezhi
 */
import '@babel/polyfill'
import Es6Promise from 'es6-promise'

require('es6-promise').polyfill()
Es6Promise.polyfill()

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
// CNimport zhCN from 'antd/es/locale/zh_';
import moment from 'moment';
import 'moment/locale/zh-cn';
Vue.config.productionTip = false
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

Vue.use(preview)
Vue.use(Antd)
moment.locale('zh-cn');

const $vma = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

export default $vma